import styled from 'styled-components';

const Status = styled.div`
  display: flex;
  > div {
    margin-right: ${({ theme }) => theme.spacing(2)};
  }
`;

export default Status;
